import styled from 'styled-components';

export const StyledPillSelector = styled.div`
  display: flex;
  text-align: center;
  width: 100%;
`;

export const StyledPillButton = styled.button`
  ${props => props.theme.typography.body};
  width: 100%;
  border: 1px solid;
  border-right: 0;
  padding: 3px 1px;
  transition: color 0.2s ease-in;
  -webkit-tap-highlight-color: transparent;
  color: ${props => props.textColor};
  background-color: ${props => props.bgColor};
  border-color: ${props => props.outlineColor};
  :last-child {
    border-right: 1px solid ${props => props.theme.colors.border.dark};
    border-top-right-radius: 21px;
    border-bottom-right-radius: 21px;
  }
  :first-child {
    border-top-left-radius: 21px;
    border-bottom-left-radius: 21px;
  }
  :hover {
    text-decoration: underline;
  }
  :focus {
    z-index: 1;
    padding: 1px 0px;
    border: 2px solid ${props => props.focusOutlineColor};
  }
  :focus:not(:last-child) {
    margin-right: -1px;
  }
`;
